import styled from 'styled-components'
import { COLORS } from 'consts/colors'

export const DividerLine = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${COLORS.borderColor};
`
